import { cn } from '@/lib/utils';

interface SolanaIconProps extends React.HTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const SolanaIcon = ({ className, ...props }: SolanaIconProps) => {
  return (
    <img
      src="/icons/sol.svg"
      alt="sol"
      className={cn('size-[16px]', className)}
      {...props}
    />
  );
};
